import RegistroPresencaActionTypes from "./action-types.ts";

export const registroPresencaState = (payload) => ({
    type: RegistroPresencaActionTypes.PRESENCA,
    payload,
});